import styled, { css } from 'styled-components';
import { rem } from 'polished';
import Icon from '../Icon';
import BoxText from '../BoxText';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

import { ButtonArrowLeft, ButtonArrowRight } from '../ButtonArrows';

// Capa principal galeria
export const StyledGallery = styled.div`
  background-color: ${props => props.theme.colors.dark}F0;
  height: 100%;
  position: fixed;
  width: 100%;
  z-index: 13;
  top: 0;
`;

// Cabecera de galeria, logo y cerrar
export const StyledHeaderGallery = styled.div`
  background-color: transparent;
  height: ${rem('71px')};
  position: absolute;
  width: 100%;
  z-index: 12;
  ${mediaqueries.greaterThan('desktop')`
    background-color: ${props => props.theme.colors.dark};
  `};
`;

// Logo Atresmil
export const StyledLogo = styled(Icon)`
  cursor: default;
  margin-top: ${rem('18px')};
  height: ${rem('35px')};
  visibility: hidden;
  width: ${rem('106px')};
  ${mediaqueries.greaterThan('desktop')`
    visibility: visible;
  `};
`;

// Caja para boton cerrar
export const StyledBoxClose = styled.button`
  align-items: center;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  display: flex;
  height: ${rem('25px')};
  justify-content: center;
  margin: ${rem('7px')} ${rem('10px')} 0 0;
  position: relative;
  width: ${rem('25px')};
  z-index: 12;
  @media (orientation: landscape) {
    background-color: ${props => props.theme.colors.dark}84;
    margin: ${rem('22px')} ${rem('22px')} 0 0;
    ${props =>
      props.modeMobile &&
      css`
        background-color: transparent;
      `};
  }
  ${mediaqueries.greaterThan('mobile')`
    height: ${rem('30px')};
    margin: ${rem('27px')} ${rem('27px')} 0 0;
    width: ${rem('30px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    margin: ${rem('25px')} 0 0 0;
  `};
`;

// Icono cerrar
export const Styledclose = styled(Icon)`
  height: ${rem('14px')};
  width: ${rem('14px')};
  ${mediaqueries.greaterThan('mobile')`
    height: ${rem('19px')};
    width: ${rem('19px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    height: ${rem('21px')};
    width: ${rem('21px')};
  `};
`;

// Capa Contenido centrado y espaciado de galeria
export const StyledHeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  ${mediaqueries.greaterThan('desktop')`
    max-width: ${rem('1232px')};
  `};
`;

// Caja posiciona contenido
export const StyledInterior = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  overflow: hidden;
  padding-top: ${rem('30px')};
  position: absolute;
  width: 100%;
`;

// Caja Navegación
export const StyledBoxNavigation = styled.div`
  position: relative;
  height: 100%;
`;

// Navegación
export const StyledNavigation = styled.ul`
  align-items: center;
  bottom: 0;
  display: flex;
  height: ${rem('55px')};
  justify-content: center;
  left: 0;
  margin: 0;
  padding: 56.25% 0 0 0;
  position: absolute;
  transform: translate(0, -50%);
  top: 52%;
  width: 100%;
  @media (max-width: 720px) and (orientation: landscape) {
    background-color: ${props => props.theme.colors.dark}7A;
    height: ${rem('40px')};
    padding-top: inherit;
    position: fixed;
    transform: inherit;
    top: inherit;
  }
  ${mediaqueries.greaterThan('desktop')`
    top:56%;
  `};
  @media (max-height: 840px) and (min-width: 1279px) {
    bottom: 3%;
    height: ${rem('12px')};
    padding: 0;
    top: inherit;
    transform: inherit;
  }
`;

// Elementos navegación
export const StyledElements = styled.li`
  background-color: ${props => props.theme.colors.light};
  cursor: pointer;
  height: ${rem('8px')};
  margin-right: ${rem('15px')};
  opacity: 0.2;
  padding-left: 0;
  width: ${rem('8px')};
  &:before {
    content: none;
  }
  &:last-child {
    margin-right: 0;
  }
  &:hover {
    opacity: 0.9;
  }
  ${props =>
    props.activePage &&
    ` opacity: 0.9;
    `};
  ${mediaqueries.greaterThan('mobile')`
    height: ${rem('10px')};
    margin-right:${rem('20px')};
    width: ${rem('10px')};
  `};
`;

// Flechas
export const StyledArrowLeft = styled(ButtonArrowLeft)`
  transform: translate3d(-100%, -50%, 0);
  ${mediaqueries.greaterThan('desktop')`
    transform: translate3d(-100%, calc(-50% - ${rem('55px')}), 0);
  `};
`;

export const StyledArrowRight = styled(ButtonArrowRight)`
  transform: translate3d(100%, -50%, 0);
  ${mediaqueries.greaterThan('desktop')`
    transform: translate3d(100%, calc(-50% - ${rem('55px')}), 0);
  `};
`;

// Texto
export const StyledBoxTextGallery = styled(BoxText)`
  ${props =>
    props.modeMobile &&
    ` transform: translate3d(0, 0, 0);
    `};
`;

// Caja posiciona contenido
export const StyledItems = styled.div`
  cursor: pointer;
  left: 50%;
  max-height: 100%;
  overflow: hidden;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  @media (max-height: 840px) and (min-width: 1279px) {
    width: auto;
  }
`;

// Caja con contenido imagen, texto hover, flechas, navegación
export const StyledBoxContent = styled.div`
  height: 100%;
  margin: 0 auto;
  position: relative;
  ${mediaqueries.greaterThan('desktop')`
    max-width: ${rem('1232px')};
    &:hover {
      ${StyledBoxTextGallery} {
        transform: translate3d(0, 0, 0);
      }
      ${StyledArrowLeft},${StyledArrowRight} {
        transform: translate3d(0, calc(-50% - ${rem('55px')}), 0);
      }
    }
  `};
  ${mediaqueries.lessThan('1279px')`
    ${props =>
      props.modeMobile &&
      css`
        ${StyledArrowLeft} {
          transform: translate3d(${rem('12px')}, -50%, 0);
        }
        ${StyledArrowRight} {
          transform: translate3d(${rem('-12px')}, -50%, 0);
        }
      `};
  `};
`;

export const StyledImg = styled.div`
  img {
    height: auto;
    width: 100%;
    @media (max-height: 840px) and (min-width: 1279px) {
      height: 80vh;
      width: auto;
    }
  }
`;
